import { useEffect, useRef } from 'react';

const POLL_INTERVAL_MS = 8000;
const MAX_DURATION_MS = 10 * 60 * 1000; // 10 min — janela folgada para a SEFAZ autorizar.

/**
 * Faz polling enquanto houver nota em EMITINDO. O `onTick` é responsável por
 * SINCRONIZAR o status no backend (chamar nfe-status), não só reler — sem isso a
 * nota nunca sai de EMITINDO no banco.
 *
 * - `onTick` é lido via ref: a identidade do callback muda a cada render (ex.: na
 *   lista, depende de `invoices`); sem a ref o `setInterval` seria recriado a cada
 *   ciclo, reiniciando o relógio do polling.
 * - Dispara um tick imediato ao detectar pendência: destrava a nota assim que a
 *   tela abre, sem depender de manter a aba aberta por minutos.
 */
export function useEmissionPolling({
  isEmitindo,
  onTick,
}: {
  isEmitindo: boolean;
  onTick: () => void;
}) {
  const onTickRef = useRef(onTick);
  onTickRef.current = onTick;

  useEffect(() => {
    if (!isEmitindo) return;

    const startedAt = Date.now();
    onTickRef.current(); // tick imediato — sincroniza ao abrir, sem esperar o 1º intervalo

    const interval = setInterval(() => {
      if (Date.now() - startedAt >= MAX_DURATION_MS) {
        clearInterval(interval);
        return;
      }
      onTickRef.current();
    }, POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [isEmitindo]);
}
